import { useEffect, useState } from 'react'
import axios from 'axios'
import toast, { Toaster } from 'react-hot-toast'
import moment from 'moment'
import './TranscriptEditor.css'
import { useHistory, Link, useParams } from 'react-router-dom'
import { HorizontalLayout } from '../Components'
import TextareaAutosize from 'react-textarea-autosize';
import { myFunction } from '../Recording/index.js';
import { generateSRT } from 'subtitle-generator';
import { TextGrid } from 'textgrid'
import DownloadButton from '../Components/DownloadButton'

const { parseXml, buildXml } = require('../Utils/xmlParser');
var ed = require('edit-distance');

var sentenceIdChanged = [];
var speakerIdChanged = [];

let speakerColorsStyleSheet = document.createElement('style')
document.head.appendChild(speakerColorsStyleSheet)

const generateRandomColors = (speakers) => {
    const num = speakers.length
    if (num === 0) return {}
    while (speakerColorsStyleSheet.sheet.rules.length !== 0) {
        speakerColorsStyleSheet.sheet.removeRule(0)
    }
    const rgbVals = [
        '238,130,238', '0,0,128', '140,76,76', '270,150,0', '102,0,0',
        '0,128,128', '0,128,0', '245,125,75', '128,0,128', '170,0,0',
        '128,128,0', '140,112,76', '255,76,66', '255,0,255', '255,112,112',
        '79,70,0', '69,94,69', '255,69,112', '71,71,184', '220,175,90'
    ]

    const speakerToClass = {}

    for (let i = 0; i < num; i++) {
        const speaker = speakers[i]
        const rgb = `rgb(${rgbVals[i % 20]})`
        let className = speaker.replace(/ /g, '_').replace(/[^a-zA-Z0-9_-]/g, '')
        speakerToClass[speaker] = className
        speakerColorsStyleSheet.sheet.insertRule(
            `.speaker_${className} { background: ${rgb} !important; color: white !important; }`
        )
    }

    return speakerToClass
}

const Sentence = ({ index, handleChanges, sentence, sentenceHandler, fileFormat, fileData }) => {
    const [sent, setSent] = useState(sentence);

    // sync when when transcript is reloaded
    useEffect(() => {
        setSent(sentence);
    }, [sentence]);

    const handleInput = (e) => {
        if (!sentenceIdChanged.includes(index)) { sentenceIdChanged.push(index); }
        handleChanges(e.target.value);
        setSent(e.target.value);
        sentenceHandler();
    }

    return (
        fileFormat.substring(fileFormat.indexOf('.') + 1) == "xml" ?
            (
                <TextareaAutosize
                    rows="2"
                    style={{ overflow: 'hidden', width: '100%', border: 'none' }}
                    value={sent}
                    onChange={handleInput.bind(this)}
                />
            ) :
            (
                <TextareaAutosize
                    rows="2"
                    style={{ overflow: 'hidden', width: '100%', border: 'none' }}
                    value={sent}
                    onChange={e => {
                        setSent(e.target.value);
                        sentenceHandler();
                        if (!sentenceIdChanged.includes(index)) { sentenceIdChanged.push(index) };
                        fileData[index].text = e.target.value;
                    }}
                />
            )
    )
}

const SpeakerInput = ({ index, speakerId, handleSpeakerChange, speakerToClass }) => {
    const [isEditing, setIsEditing] = useState(false);
    const [editedSpeakerId, setEditedSpeakerId] = useState(speakerId);

    // Sync when parent speakerId changes
    useEffect(() => {
        setEditedSpeakerId(speakerId);
    }, [speakerId]);

    const handleClick = () => setIsEditing(true);

    const handleBlur = () => {
        setIsEditing(false);
        if (editedSpeakerId !== speakerId) {
            handleSpeakerChange(index, editedSpeakerId);
        }
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            setIsEditing(false);
            if (editedSpeakerId !== speakerId) {
                handleSpeakerChange(index, editedSpeakerId);
            }
        } else if (e.key === 'Escape') {
            setIsEditing(false);
            setEditedSpeakerId(speakerId);
        }
    };

    // Use committed speakerId for color (not mid-edit value)
    const colorClass = speakerToClass?.[speakerId]
        ? `speaker_${speakerToClass[speakerId]}`
        : '';

    return isEditing ? (
        <input
            className="speakerTagInput"
            type="text"
            value={editedSpeakerId}
            onChange={(e) => setEditedSpeakerId(e.target.value)}
            onBlur={handleBlur}
            onKeyDown={handleKeyDown}
            autoFocus
        />
    ) : (
        <div className={`speakerTag ${colorClass}`} onClick={handleClick}>
            {speakerId}
        </div>
    );
};

const getTranscriptSentence = (words) => {
    var sentences = words.map(s => s._);
    return sentences.join(' ');
}

const TranscriptButton = ({
    transcripts = [],
    selectedTranscript,
    setSelectedTranscriptId,
}) => {
    const role = localStorage.getItem('role')
    if (role !== 'admin' && role !== 'uploader') return null
    if (!selectedTranscript) return null

    return (
        <label className="editorTranscriptPicker">
            <span>Transcript:</span>
            <select
                className="editorTranscriptSelect"
                value={selectedTranscript._id}
                onChange={(e) => setSelectedTranscriptId(e.target.value)}
                title={selectedTranscript.name}
            >
                {transcripts.map((t) => (
                    <option key={t._id} value={t._id}>
                        {t.name}
                    </option>
                ))}
            </select>
        </label>
    )
}

const TranscriptEditor = ({
    transcriptData,
    jumpTo,
    fileName,
    handleWordChange,
    transcriptXMLPath,
    transcriptId,
    onDraftSaved,
    transcripts = [],
    selectedTranscript,
    setSelectedTranscriptId,
}) => {

    const [editedTranscriptState, setBtnState] = useState(false);
    const [originalFullScript, setFullScript] = useState(null);
    const [originalScriptWordsOnly, setScript] = useState(null);
    const [defaultScript, setChangeURL] = useState(myFunction());
    const [speakerChanges, setSpeakerChanges] = useState({});
    const [speakerToClass, setSpeakerToClass] = useState({});

    function getOriginalTranscript() {
        if (transcriptXMLPath.substring(transcriptXMLPath.indexOf('.') + 1) == "xml") {
            const draftPath = `${process.env.REACT_APP_STUDIO_URL}/static/transcripts/draft/${fileName}`;
            const originalPath = `${process.env.REACT_APP_STUDIO_URL}/static/transcripts/${fileName}`;

            axios.get(draftPath)
                .then((response) => {
                    const json = parseXml(response.data, { processAttributeValues: false });
                    setFullScript(json);
                    let wordsOnly = {}
                    let parser = new DOMParser()
                    let html = parser.parseFromString(response.data, "text/html")
                    for (let i = 0; i < html.getElementsByTagName("speechsegment").length; i++) {
                        wordsOnly[i] = html.getElementsByTagName("speechsegment")[i].textContent.replace(/(\r\n|\n|\r|\t|\s)+/g, " ").trim().split(' ');
                    }
                    setScript(wordsOnly)
                })
                .catch(() => {
                    axios.get(originalPath)
                        .then((response) => {
                            const json = parseXml(response.data, { processAttributeValues: false });
                            setFullScript(json);
                            let wordsOnly = {}
                            let parser = new DOMParser()
                            let html = parser.parseFromString(response.data, "text/html")
                            for (let i = 0; i < html.getElementsByTagName("speechsegment").length; i++) {
                                wordsOnly[i] = html.getElementsByTagName("speechsegment")[i].textContent.replace(/(\r\n|\n|\r|\t|\s)+/g, " ").trim().split(' ');
                            }
                            setScript(wordsOnly)
                        })
                        .catch((err) => console.log('Failed to load original:', err))
                })
        } else if (transcriptXMLPath.substring(transcriptXMLPath.indexOf('.') + 1) == "TextGrid") {
            axios.get(`${process.env.REACT_APP_STUDIO_URL}/static/transcripts/${fileName}`)
                .then(response => {
                    const json = TextGrid.textgridToJSON(response.data)
                    setFullScript(json);
                })
        }
    }

    // reloads when the selected transcript changes (pending edits are dropped)
    useEffect(() => {
        sentenceIdChanged = [];
        speakerIdChanged = [];
        setSpeakerChanges({});
        setBtnState(false);
        if (transcriptXMLPath && fileName) getOriginalTranscript();
    }, [transcriptXMLPath, fileName])

    // Generate speaker colors from transcriptData
    useEffect(() => {
        if (!transcriptData) return;

        const speakers = new Set();

        if (transcriptData.AudioDoc?.SegmentList) {
            // XML format
            for (const sl of transcriptData.AudioDoc.SegmentList) {
                for (const ss of sl.SpeechSegment) {
                    if (ss.$?.spkrid) speakers.add(ss.$.spkrid);
                }
            }
        } else if (Array.isArray(transcriptData) && transcriptData[0]?.speaker) {
            // STM format
            transcriptData.forEach(seg => { if (seg.speaker) speakers.add(seg.speaker) });
        } else if (Array.isArray(transcriptData) && transcriptData[0]?.tierName) {
            // TextGrid format
            transcriptData.forEach(seg => { if (seg.tierName) speakers.add(seg.tierName) });
        }
        
        Object.values(speakerChanges).forEach(name => { if (name) speakers.add(name) });

        const speakerArray = Array.from(speakers).filter(Boolean);
        if (speakerArray.length > 0) {
            setSpeakerToClass(generateRandomColors(speakerArray));
        }
    }, [transcriptData, speakerChanges])

    // Regenerate colors when speakers are renamed
    useEffect(() => {
        if (Object.keys(speakerChanges).length === 0) return;

        const speakers = new Set();

        if (transcriptData?.AudioDoc?.SegmentList) {
            for (const sl of transcriptData.AudioDoc.SegmentList) {
                for (const ss of sl.SpeechSegment) {
                    if (ss.$?.spkrid) speakers.add(ss.$.spkrid);
                }
            }
        } else if (Array.isArray(transcriptData) && transcriptData[0]?.speaker) {
            transcriptData.forEach(seg => { if (seg.speaker) speakers.add(seg.speaker) });
        } else if (Array.isArray(transcriptData) && transcriptData[0]?.tierName) {
            transcriptData.forEach(seg => { if (seg.tierName) speakers.add(seg.tierName) });
        }

        // Add renamed speaker names so they get colors too
        Object.values(speakerChanges).forEach(name => { if (name) speakers.add(name) });

        const speakerArray = Array.from(speakers).filter(Boolean);
        if (speakerArray.length > 0) {
            setSpeakerToClass(generateRandomColors(speakerArray));
        }
    }, [speakerChanges])

    const sentenceHandler = () => {
        setBtnState(true);
    }

    const getOriginalSpeakerIdAt = (index) => {
        try {
            if (transcriptXMLPath.endsWith('.xml')) {
                let count = 0;
                for (const sl of transcriptData.AudioDoc.SegmentList) {
                    for (const ss of sl.SpeechSegment) {
                        if (count === index) return ss.$.spkrid;
                        count++;
                    }
                }
            } else if (transcriptXMLPath.endsWith('.stm')) {
                return transcriptData[index]?.speaker;
            } else if (transcriptXMLPath.endsWith('.TextGrid')) {
                return transcriptData[index]?.tierName;
            }
        } catch (e) { }
        return null;
    };


    const getSpeakerGroups = () => {
        const groups = {};
        try {
            if (transcriptXMLPath.endsWith('.xml')) {
                let count = 0;
                transcriptData.AudioDoc.SegmentList.forEach((sl) => {
                    sl.SpeechSegment.forEach((ss) => {
                        const origId = ss.$?.spkrid;
                        if (origId) {
                            if (!groups[origId]) groups[origId] = [];
                            groups[origId].push(count);
                        }
                        count++;
                    });
                });
            } else if (transcriptXMLPath.endsWith('.stm')) {
                transcriptData.forEach((seg, i) => {
                    const origId = seg.speaker;
                    if (origId) {
                        if (!groups[origId]) groups[origId] = [];
                        groups[origId].push(i);
                    }
                });
            } else if (transcriptXMLPath.endsWith('.TextGrid')) {
                transcriptData.forEach((seg, i) => {
                    const origId = seg.tierName;
                    if (origId) {
                        if (!groups[origId]) groups[origId] = [];
                        groups[origId].push(i);
                    }
                });
            }
        } catch (e) { }
        return groups;
    };

    // auto-suffix on speaker name collision (prevent duplicate names)
    const handleSpeakerChange = (index, newSpeakerId) => {
        const originalSpeakerId = getOriginalSpeakerIdAt(index);

        if (transcriptXMLPath.endsWith('.xml') || transcriptXMLPath.endsWith('.stm') || transcriptXMLPath.endsWith('.TextGrid')) {
            if (!originalSpeakerId) return;

            const groups = getSpeakerGroups();
            const ownIndices = groups[originalSpeakerId] || [index];

            setSpeakerChanges(prev => {
                const otherNames = new Set();
                Object.keys(groups).forEach((groupId) => {
                    if (groupId === originalSpeakerId) return;
                    const repIndex = groups[groupId][0];
                    const effectiveName = prev[repIndex] || groupId;
                    otherNames.add(effectiveName);
                });

                let finalName = newSpeakerId;
                if (otherNames.has(finalName)) {
                    let n = 2;
                    while (otherNames.has(`${newSpeakerId}_${n}`)) n++;
                    finalName = `${newSpeakerId}_${n}`;
                }

                const updated = { ...prev };
                ownIndices.forEach((i) => {
                    updated[i] = finalName;
                    if (!speakerIdChanged.includes(i)) speakerIdChanged.push(i);
                });
                return updated;
            });
        } else {
            setSpeakerChanges(prev => ({ ...prev, [index]: newSpeakerId }));
            if (!speakerIdChanged.includes(index)) speakerIdChanged.push(index);
        }

        setBtnState(true);
    };

    const { id } = useParams();

    const handleSave = () => {
        if (!originalFullScript) {
            toast.error('Transcript not loaded. Please refresh the page.');
            return;
        }

        if (window.confirm('Are you sure you want to save?\n\nPlease ensure that all words are separated by a space or the results after download will not be correct.')) {
            setChangeURL(false);

            var insert, remove, update;
            insert = remove = function () { return 1; };
            update = function (stringA, stringB) { return stringA !== stringB ? 1 : 0; };

            var changedScriptMap = {}

            if (transcriptXMLPath.substring(transcriptXMLPath.indexOf('.') + 1) == "xml") {
                for (let i = 0; i < sentenceIdChanged.length; i++) {
                    let newScript = transcriptData.AudioDoc.SegmentList[0].SpeechSegment[sentenceIdChanged[i]].Word[0]._.split(/\s+/);
                    let lev = ed.levenshtein(originalScriptWordsOnly[sentenceIdChanged[i]], newScript, insert, remove, update);
                    changedScriptMap[sentenceIdChanged[i]] = []
                    let arrLen = lev.pairs().length;
                    lev.pairs().reverse();
                    for (let j = 0; j < arrLen; j++) {
                        if (lev.pairs()[j][0] != lev.pairs()[j][1]) {
                            if (lev.pairs()[j][0] != null && lev.pairs()[j][1] == null) {
                                changedScriptMap[sentenceIdChanged[i]].push({ [j]: 'deleted by ' })
                            } else if (lev.pairs()[j][0] == null && lev.pairs()[j][1] != null) {
                                changedScriptMap[sentenceIdChanged[i]].push({ [j]: 'inserted by ' + lev.pairs()[j][1] })
                            } else {
                                changedScriptMap[sentenceIdChanged[i]].push({ [j]: 'replaced by ' + lev.pairs()[j][1] })
                            }
                        }
                    }
                }

                for (var i in changedScriptMap) {
                    let deletedWords = 0;
                    for (let j = 0; j < changedScriptMap[i].length; j++) {
                        for (var k in changedScriptMap[i][j]) {
                            k = parseInt(k);
                            let operation = changedScriptMap[i][j][k].split(' ').slice(0)[0].toString();
                            let newWord = changedScriptMap[i][j][k].split(' ').slice(2).toString();
                            if (operation == "replaced") {
                                originalFullScript.AudioDoc.SegmentList[0].SpeechSegment[i].Word[k - deletedWords]._ = newWord;
                            } else if (operation == "deleted") {
                                originalFullScript.AudioDoc.SegmentList[0].SpeechSegment[i].Word.splice(k - deletedWords, 1);
                                deletedWords++;
                            } else {
                                var newChange;
                                k == 0
                                    ? newChange = Object.assign({}, originalFullScript.AudioDoc.SegmentList[0].SpeechSegment[i].Word[k - deletedWords])
                                    : newChange = Object.assign({}, originalFullScript.AudioDoc.SegmentList[0].SpeechSegment[i].Word[k - deletedWords - 1]);
                                newChange._ = newWord;
                                originalFullScript.AudioDoc.SegmentList[0].SpeechSegment[i].Word.splice(k - deletedWords, 0, newChange);
                            }
                        }
                    }
                }

                for (var i in speakerChanges) {
                    const speechSegments =
                        originalFullScript.AudioDoc.SegmentList[0].SpeechSegment;
                    if (speechSegments && speechSegments[i]) {
                        if (speechSegments[i].$) {
                            speechSegments[i].$.spkrid = speakerChanges[i];
                        }
                    }
                }

                var editedTranscript = buildXml(originalFullScript);

                if (!editedTranscript.includes('<AudioDoc')) {
                    toast.error('Failed to save transcript: Invalid XML structure')
                    return
                }

                try {
                    const parser = new DOMParser()
                    const xmlDoc = parser.parseFromString(editedTranscript, "text/xml")
                    const parseError = xmlDoc.getElementsByTagName("parsererror")
                    if (parseError.length > 0) {
                        toast.error('Failed to save transcript: XML parsing error')
                        return
                    }
                } catch (e) {
                    toast.error('Failed to save transcript: XML validation error')
                    return
                }
            } else if (transcriptXMLPath.substring(transcriptXMLPath.indexOf('.') + 1) == "srt") {
                function secondsToTime(secs) {
                    var hours = Math.floor(secs / (60 * 60)).toString();
                    var divisor_for_minutes = secs % (60 * 60);
                    var minutes = Math.floor(divisor_for_minutes / 60).toString();
                    var divisor_for_seconds = divisor_for_minutes % 60;
                    var seconds = divisor_for_seconds.toFixed(3);
                    hours = hours.length == 1 ? "0" + hours : hours;
                    minutes = minutes.length == 1 ? "0" + minutes : minutes;
                    var secondsFront = seconds.split('.')[0].length == 1 ? "0" + seconds.split('.')[0].toString() : seconds.split('.')[0].toString();
                    seconds = secondsFront + "," + seconds.split('.')[1];
                    return hours + ":" + minutes + ":" + seconds
                }

                const data = []
                for (let i = 0; i < transcriptData.length; i++) {
                    data.push({ start: secondsToTime(transcriptData[i].start), end: secondsToTime(transcriptData[i].end), content: transcriptData[i].text })
                }
                var editedTranscript = generateSRT(data, 'timestamp');

            } else if (transcriptXMLPath.substring(transcriptXMLPath.indexOf('.') + 1) == "TextGrid") {
                for (let i = 0; i < sentenceIdChanged.length; i++) {
                    var itemIndex = transcriptData[sentenceIdChanged[i]].itemIndex;
                    var intervalIndex = transcriptData[sentenceIdChanged[i]].intervalIndex;
                    var newText = transcriptData[sentenceIdChanged[i]].text;
                    originalFullScript.items[itemIndex].intervals[intervalIndex].text = newText;
                }
                for (var i in speakerChanges) {
                    if (transcriptData[i] && transcriptData[i].itemIndex !== undefined) {
                        originalFullScript.items[transcriptData[i].itemIndex].name = speakerChanges[i];
                    }
                }
                var editedTranscript = jsonToTextGrid(originalFullScript);

            } else {
                const stmDataWithSpeakers = transcriptData.map((data, index) => {
                    if (speakerChanges[index]) {
                        return { ...data, speaker: speakerChanges[index] };
                    }
                    return data;
                });
                var editedTranscript = jsonToSTM(stmDataWithSpeakers);
            }

            axios.put(
                `${process.env.REACT_APP_STUDIO_URL}/upload/transcript`,
                { fileName, data: editedTranscript, isDraft: true }
            ).then(() => {
                toast.success('Transcript saved in draft successfully');
                setBtnState(false);
                sentenceIdChanged = [];
                speakerIdChanged = [];
                changedScriptMap = {};
                // Keep speakerChanges intact so display stays correct
                getOriginalTranscript();
                if (onDraftSaved) {
                    onDraftSaved(`transcripts/draft/${fileName}`);
                }
            }).catch(err => toast.error(err.message))
        }
    }

    function jsonToTextGrid(script) {
        var strToReturn = "";
        var fileHeaders = "File type = \"" + script.File_type + "\"" + "\nObject class = \"TextGrid\"" +
            "\n\nxmin = 0" + "\nxmax = " + script.xmax + "\ntiers? <exist>" + "\nsize = " + script.size;
        var items = "\nitem []:";
        for (let i = 0; i < script.items.length; i++) {
            items += `\n    item [${i + 1}]` + `\n        class = "${script.items[i].class}"` + `\n        name = "${script.items[i].name}"`
                + `\n        xmin = ${script.items[i].xmin}` + `\n        xmax = ${script.items[i].xmax}` + `\n        intervals: size = ${script.items[i].intervals_size}`;
            for (let j = 0; j < script.items[i].intervals.length; j++) {
                items += `\n        intervals [${j + 1}]:` +
                    `\n            xmin = ${script.items[i].intervals[j].xmin}` +
                    `\n            xmax = ${script.items[i].intervals[j].xmax}` +
                    `\n            text = "${script.items[i].intervals[j].text}"`;
            }
        }
        strToReturn += fileHeaders + items;
        return strToReturn;
    }

    function jsonToSTM(script) {
        var strToReturn = "";
        for (let i = 0; i < script.length; i++) {
            if (i == 0) {
                strToReturn += `${script[i].fileName} ${script[i].a} ${script[i].speaker} ${script[i].start} ${script[i].end} ${script[i].gender} ${script[i].text}`;
            } else {
                strToReturn += `\n${script[i].fileName} ${script[i].a} ${script[i].speaker} ${script[i].start} ${script[i].end} ${script[i].gender} ${script[i].text}`;
            }
        }
        return strToReturn;
    }

    return (
        <div>
            <HorizontalLayout className="align-items-center">
                <TranscriptButton
                    transcripts={transcripts}
                    selectedTranscript={selectedTranscript}
                    setSelectedTranscriptId={setSelectedTranscriptId}
                />
                <DownloadButton
                    fileName={fileName}
                    transcriptId={transcriptId}
                />
                <button
                    id='saveButton'
                    onClick={() => {
                        if (editedTranscriptState) {
                            handleSave()
                        } else {
                            window.alert('Please edit transcript before saving.');
                        }
                    }}
                    className={editedTranscriptState ? "btn btn-success" : "btn btn-secondary"}
                >
                    Save
                </button>
                <div className="ml-auto">
                    <Link className="ml-auto" to={`/transcriptStudio/${id}`}>
                        Go to Magor Transcript Studio
                    </Link>
                </div>
            </HorizontalLayout>
            <div className="transcript-editor">
                {transcriptXMLPath.substring(transcriptXMLPath.indexOf('.') + 1) == "xml" ?
                    (transcriptData &&
                        transcriptData.AudioDoc.SegmentList.map((sl, slIndex) =>
                            sl.SpeechSegment
                                .sort((a, b) => a.$.stime * 1000 > b.$.stime * 1000 ? 1 : -1)
                                .map((ss, ssIndex) => (
                                    <div className="speechSegment" key={ss.$.stime.toString()}>
                                        <div className="segmentHeader">
                                            <label
                                                className="timestamp"
                                                onClick={() => jumpTo(ss.$.stime * 1000)}
                                            >
                                                {moment.utc(ss.$.stime * 1000).format('HH:mm:ss')}
                                            </label>
                                            <SpeakerInput
                                                index={ssIndex}
                                                speakerId={speakerChanges[ssIndex] || ss.$.spkrid}
                                                handleSpeakerChange={handleSpeakerChange}
                                                speakerToClass={speakerToClass}
                                            />
                                        </div>
                                        <div className="transcriptBox">
                                            <Sentence
                                                index={ssIndex}
                                                handleChanges={(value) => handleWordChange(slIndex, ssIndex, value, transcriptXMLPath)}
                                                sentence={getTranscriptSentence(ss.Word)}
                                                sentenceHandler={sentenceHandler}
                                                fileFormat={transcriptXMLPath}
                                            />
                                        </div>
                                    </div>
                                ))
                        )
                    ) : transcriptXMLPath.substring(transcriptXMLPath.indexOf('.') + 1) == "srt" ?
                        (transcriptData &&
                            transcriptData?.map((data, index) =>
                                <div className="speechSegment" key={data.start.toString()}>
                                    <div className="segmentHeader">
                                        <label
                                            className="timestamp"
                                            onClick={() => jumpTo(data.start * 1000)}
                                        >
                                            {moment.utc(data.start * 1000).format('HH:mm:ss')}
                                        </label>
                                    </div>
                                    <div className="transcriptBox">
                                        <Sentence
                                            index={index}
                                            handleChanges={(value) => handleWordChange(0, index, value, transcriptXMLPath)}
                                            sentence={data.text}
                                            sentenceHandler={sentenceHandler}
                                            fileFormat={transcriptXMLPath}
                                            fileData={transcriptData}
                                        />
                                    </div>
                                </div>
                            )
                        ) : transcriptXMLPath.substring(transcriptXMLPath.indexOf('.') + 1) == "TextGrid" ?
                            (transcriptData &&
                                transcriptData?.map((data, index) =>
                                    <div className="speechSegment" key={data.xmin.toString()}>
                                        <div className="segmentHeader">
                                            <label
                                                className="timestamp"
                                                onClick={() => jumpTo(data.xmin * 1000)}
                                            >
                                                {moment.utc(data.xmin * 1000).format('HH:mm:ss')}
                                            </label>
                                            <SpeakerInput
                                                index={index}
                                                speakerId={speakerChanges[index] || data.tierName}
                                                handleSpeakerChange={handleSpeakerChange}
                                                speakerToClass={speakerToClass}
                                            />
                                        </div>
                                        <div className="transcriptBox">
                                            <Sentence
                                                index={index}
                                                handleChanges={(value) => handleWordChange(data.itemIndex, data.intervalIndex, value, transcriptXMLPath)}
                                                sentence={data.text}
                                                sentenceHandler={sentenceHandler}
                                                fileFormat={transcriptXMLPath}
                                                fileData={transcriptData}
                                            />
                                        </div>
                                    </div>
                                )
                            ) : transcriptXMLPath.substring(transcriptXMLPath.indexOf('.') + 1) == "stm" ?
                                (transcriptData &&
                                    transcriptData.map((data, index) =>
                                        <div className="speechSegment" key={data.start.toString()}>
                                            <div className="segmentHeader">
                                                <label
                                                    className="timestamp"
                                                    onClick={() => jumpTo(data.start * 1000)}
                                                >
                                                    {moment.utc(data.start * 1000).format('HH:mm:ss')}
                                                </label>
                                                <SpeakerInput
                                                    index={index}
                                                    speakerId={speakerChanges[index] || data.speaker}
                                                    handleSpeakerChange={handleSpeakerChange}
                                                    speakerToClass={speakerToClass}
                                                />
                                            </div>
                                            <div className="transcriptBox">
                                                <Sentence
                                                    index={index}
                                                    handleChanges={(value) => handleWordChange(0, index, value, transcriptXMLPath)}
                                                    sentence={data.text}
                                                    sentenceHandler={sentenceHandler}
                                                    fileFormat={transcriptXMLPath}
                                                    fileData={transcriptData}
                                                />
                                            </div>
                                        </div>
                                    )
                                ) : (
                                    <p>Text</p>
                                )
                }
            </div>

            <Toaster
                position="bottom-right"
                reverseOrder
                toastOptions={{
                    style: {
                        borderRadius: '10px',
                        background: '#333',
                        color: '#fff',
                    },
                }}
            />
        </div>
    )
}

export default TranscriptEditor